import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { getTranslations, ITranslations } from '../../../services/translations'
import { useConfigContext } from '../App'

const Wrapper = styled.div`
  display: flex;
  align-items: baseline;
  padding: 0 2rem;

  .time {
    font-size: 6.045rem;
    font-weight: bold;
    margin-right: 2rem;
  }

  .date {
    font-size: 2.6rem;
  }
`

const Clock = () => {
  const [dateTime, setDateTime] = useState(new Date())
  const { langCode } = useConfigContext()
  const translations: ITranslations = getTranslations(langCode)
  const minutes = dateTime.getMinutes() < 10 ? `0${dateTime.getMinutes()}` : dateTime.getMinutes()

  useEffect(() => {
    const interval = setInterval(() => setDateTime(new Date()), 1000)

    return () => clearInterval(interval)
  })

  return (
    <Wrapper>
      <div className="time">
        {dateTime.getHours()}:{minutes}
      </div>
      <div className="date">
        {`${translations[`dayOfWeek${dateTime.getDay()}`]} `}
        {dateTime.getDate() + '. '}
        {translations[`month${dateTime.getMonth()}_2nd`]}
      </div>
    </Wrapper>
  )
}

export default Clock
